import React from 'react';
import { useTable, Column } from 'react-table';
import { Link } from 'react-router-dom';
import { formatOrderDate } from '../../../../lib/formatOrderDate';

import { useAppSelector } from '../../../../app/hooks';
import { Order, dumpsterSizeToText, DumpsterSize } from '../../../../models';

import './PendingOrdersTable.scss';

type ColumnsType = Order;

export function PendingOrdersTable() {
  const orders = useAppSelector(state => state.clientDashboard.pendingOrders);

  const columns: Array<Column<ColumnsType>> = React.useMemo(
    () => [
      {
        Header: 'Address',
        accessor: cell => `${cell.address}, ${cell.zip}`,
        width: 300
      },
      {
        Header: 'Dumpster Size',
        accessor: cell => dumpsterSizeToText[cell.dumpsterSize as DumpsterSize],
        width: 150
      },
      {
        Header: 'Delivery Date',
        accessor: cell => formatOrderDate(cell.deliveryDate),
        width: 150
      },
      {
        Header: 'Pickup Date',
        accessor: cell => formatOrderDate(cell.pickupDate),
        width: 150
      },
      {
        Header: 'Actions',
        accessor: 'id',
        width: 200,
        Cell: props => {
          const { value } = props;

          return (
            <div className='actions-cell'>
              <Link to={`/cancel-order?order_id=${value}`} className='cancel-button'>Cancel</Link>
            </div>
          );
        }
      }
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data: orders });

  if (orders.length === 0) return (
    <div className='pending-orders-table-component empty-state'>
      <div className='text'>There are no pending orders.</div>
    </div>
  );

  return (
    <div className='pending-orders-table-component'>
      <table {...getTableProps()} className='new-table'>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps({
                  style: { minWidth: column.minWidth, width: column.width },
                })}>
                  <div className='header-cell'>
                    {column.render('Header')}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  );
}
